import React, {PropsWithChildren, useEffect, useRef, useState} from "react";
import {Table} from "react-bootstrap";
import "./rr-table.css";

type RRTableProps = PropsWithChildren<{
    autoHeight?: boolean;
    bottomOffset?: number;
    minHeight?: number;
    tableClassName?: string;
}>;

const RRTable = React.forwardRef<HTMLTableElement, RRTableProps>((props, ref) => {
    const {
        children,
        autoHeight = false,
        bottomOffset = 40,
        minHeight = 220,
        tableClassName
    } = props;
    const containerRef = useRef<HTMLDivElement>(null);
    const [tableHeight, setTableHeight] = useState<number | undefined>(undefined);

    useEffect(() => {
        if (!autoHeight) {
            setTableHeight(undefined);
            return;
        }

        const updateTableHeight = () => {
            if (!containerRef.current) return;
            const top = containerRef.current.getBoundingClientRect().top;
            const availableHeight = Math.floor(window.innerHeight - top - bottomOffset);
            setTableHeight(Math.max(minHeight, availableHeight));
        };

        updateTableHeight();
        window.addEventListener("resize", updateTableHeight);
        return () => window.removeEventListener("resize", updateTableHeight);
    }, [autoHeight, bottomOffset, children, minHeight]);

    return (
        <div
            ref={containerRef}
            className="tableFixHead"
            style={tableHeight ? {height: `${tableHeight}px`} : undefined}
        >
            <Table
                ref={ref}
                variant={"light"}
                size={"sm"}
                bordered
                hover
                className={tableClassName ? `rr-table ${tableClassName}` : "rr-table w-100"}
            >
                {children}
            </Table>
        </div>
    )
});

RRTable.displayName = "RRTable";

export default RRTable;
